import React from "react";
import styled from "styled-components";

const TidalDashboardWebhookGlobalStatsWrapper = styled.div<{
  type: number;
}>`
  height: 49px;
  display: grid;
  grid-template-columns: 49px 1fr;

  
  & > .icon-container {
    height: 49px;
    width: 49px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
    background-color: ${(props) =>
      props.type == 0
        ? props.theme.colors.accent
        : props.type == 1
        ? props.theme.colors.tags[0]
        : props.theme.colors.tags[4]};
  }
  & > .stats-container {
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
    padding: 0 11px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    background-color: ${(props) =>
      props.type == 0
        ? `${props.theme.colors.accent}3d`
        : props.type == 1
        ? `${props.theme.colors.tags[0]}3d`
        : `${props.theme.colors.tags[4]}3d`};

    & > .stats-count {
      font-weight: 600;
      font-size: 14px;
      line-height: 12px;
      color: ${(props) => props.theme.colors.text[1]};
    }
    & > .stats-text {
      font-weight: 600;
      font-size: 12px;
      line-height: 12px;
      color: ${(props) =>
        props.type == 0
          ? props.theme.colors.accent
          : props.type == 1
          ? props.theme.colors.tags[0]
          : props.theme.colors.tags[4]};
    }
  }
`;

interface TidalDashboardWebhookGlobalStatsProps {
  type: number;
  Icon: any;
  count: number;
  text: string;
}

const TidalDashboardWebhookGlobalStats = ({
  type,
  Icon,
  count,
  text,
}: TidalDashboardWebhookGlobalStatsProps) => {
  return (
    <TidalDashboardWebhookGlobalStatsWrapper type={type}>
      <div className="icon-container">
        <Icon />
      </div>
      <div className="stats-container">
        <p className="stats-count">{count}</p>
        <p className="stats-text">{text}</p>
      </div>
    </TidalDashboardWebhookGlobalStatsWrapper>
  );
};

export default TidalDashboardWebhookGlobalStats;
